<template>
  <header class="main-header">
    <nav class="navbar navbar-static-top">
      <div class="container">
        <div class="navbar-header">
          <a :href="appenv.website" class="navbar-brand"
            ><b>HARBOUR CITY WEBSITE</b></a
          >
          <button
            type="button"
            class="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#navbar-collapse"
          >
            <i class="fa fa-bars"></i>
          </button>
        </div>
        <div class="collapse navbar-collapse pull-left" id="navbar-collapse">
          <ul class="nav navbar-nav">
            <li class="">
              <router-link to="/"
                >HOME <span class="sr-only">(current)</span></router-link
              >
            </li>
            <li><router-link to="/special">SPECIAL PROGRAMME</router-link></li>
            <li><router-link to="/wassce">WASSCE APPLICATION</router-link></li>
            <li>
              <router-link to="/professional"
                >PROFESSIONAL PROGRAMME</router-link
              >
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: "hnavbar",
};
</script>
<style scoped></style>
